import { useState, useEffect } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { X, ChevronLeft, ChevronRight, ZoomIn } from "lucide-react";

const PHOTOS = [
  {
    src: "https://customer-assets.emergentagent.com/job_forcacar-jundiai/artifacts/tczhrykx_unnamed%20%281%29.webp",
    title: "Estrutura Premium",
    desc: "Range Rover Evoque sob elevador hidráulico 4000kg na nossa oficina especializada.",
    tag: "Câmbio Automático",
    span: "lg:col-span-2 lg:row-span-2",
  },
  {
    src: "https://customer-assets.emergentagent.com/job_forcacar-jundiai/artifacts/3tdd7200_unnamed%20%282%29.webp",
    title: "Veículos Premium",
    desc: "Porsche Panamera Turbo V8 em atendimento na Full Force.",
    tag: "Linha Premium",
    span: "lg:col-span-2",
  },
  {
    src: "https://customer-assets.emergentagent.com/job_forcacar-jundiai/artifacts/3mqsegct_unnamed%20%283%29.webp",
    title: "Paixão Automotiva",
    desc: "Mercedes-Benz SLK em manutenção — ambiente que respira automobilismo.",
    tag: "Mecânica Especializada",
    span: "",
  },
  {
    src: "https://customer-assets.emergentagent.com/job_forcacar-jundiai/artifacts/g7c1tna6_unnamed%20%284%29.webp",
    title: "Motor de Alta Performance",
    desc: "Serviço detalhado em motor V8/V12 com inspeção interna profunda.",
    tag: "Mecânica Pesada",
    span: "",
  },
  {
    src: "https://customer-assets.emergentagent.com/job_forcacar-jundiai/artifacts/6asmgh9m_unnamed%20%285%29.webp",
    title: "Diagnóstico em Ação",
    desc: "Atendimento técnico profissional — VW Jetta em diagnóstico completo.",
    tag: "Diagnóstico",
    span: "lg:col-span-2",
  },
  {
    src: "https://customer-assets.emergentagent.com/job_forcacar-jundiai/artifacts/e656mxy3_unnamed%20%289%29.webp",
    title: "BMW X6 M no Box",
    desc: "BMW X6 M Coupé azul em atendimento — performance e precisão.",
    tag: "Linha Premium",
    span: "lg:col-span-2 lg:row-span-2",
  },
  {
    src: "https://customer-assets.emergentagent.com/job_forcacar-jundiai/artifacts/xonezvml_unnamed%20%286%29.webp",
    title: "Inspeção Detalhada",
    desc: "Hyundai i30 em revisão preventiva com checagem completa.",
    tag: "Revisão Preventiva",
    span: "",
  },
  {
    src: "https://customer-assets.emergentagent.com/job_forcacar-jundiai/artifacts/o55hl55f_unnamed%20%288%29.webp",
    title: "Esportivo BMW M",
    desc: "BMW X6 M ao lado de outros veículos premium em nossa garagem.",
    tag: "Premium",
    span: "",
  },
  {
    src: "https://customer-assets.emergentagent.com/job_forcacar-jundiai/artifacts/65zzrtl9_unnamed%20%287%29.webp",
    title: "Porsche no Elevador",
    desc: "Porsche em serviço de suspensão e freios — atenção a cada detalhe.",
    tag: "Freios e Suspensão",
    span: "lg:col-span-2",
  },
  {
    src: "https://customer-assets.emergentagent.com/job_forcacar-jundiai/artifacts/iw5288xs_unnamed%20%2810%29.webp",
    title: "Mercedes-Benz SLK",
    desc: "SLK conversível em manutenção — câmbio automático sob nossa especialidade.",
    tag: "Câmbio Automático",
    span: "lg:col-span-2",
  },
  {
    src: "https://customer-assets.emergentagent.com/job_forcacar-jundiai/artifacts/etj8vue1_unnamed.webp",
    title: "Fachada Full Force Car Premium",
    desc: "Nossa sede em Jundiaí — Porsche 911, Camaro e linha premium ao público.",
    tag: "Nossa Sede",
    span: "lg:col-span-2 lg:row-span-2",
  },
  {
    src: "https://customer-assets.emergentagent.com/job_forcacar-jundiai/artifacts/h3f5y82j_unnamed%20%2812%29.webp",
    title: "Garagem Cheia de Premium",
    desc: "BMW Série 3, Audi, Porsche e linha premium em atendimento simultâneo.",
    tag: "Estrutura",
    span: "lg:col-span-2",
  },
  {
    src: "https://customer-assets.emergentagent.com/job_forcacar-jundiai/artifacts/p1iua3iz_unnamed%20%2813%29.webp",
    title: "BMW Série 4 Vermelho",
    desc: "BMW Série 4 Coupé pronto para entrega após manutenção completa.",
    tag: "Linha Premium",
    span: "",
  },
  {
    src: "https://customer-assets.emergentagent.com/job_forcacar-jundiai/artifacts/ajun7zhq_unnamed%20%2814%29.webp",
    title: "Camaro V8 em Mecânica",
    desc: "Chevrolet Camaro amarelo em reparo de motor V8 — mecânica pesada.",
    tag: "Mecânica Pesada",
    span: "",
  },
];

export default function Gallery() {
  const [active, setActive] = useState(null);

  // Keyboard nav
  useEffect(() => {
    if (active === null) return;
    const onKey = (e) => {
      if (e.key === "Escape") setActive(null);
      if (e.key === "ArrowRight") setActive((i) => (i + 1) % PHOTOS.length);
      if (e.key === "ArrowLeft") setActive((i) => (i - 1 + PHOTOS.length) % PHOTOS.length);
    };
    window.addEventListener("keydown", onKey);
    document.body.style.overflow = "hidden";
    return () => {
      window.removeEventListener("keydown", onKey);
      document.body.style.overflow = "";
    };
  }, [active]);

  return (
    <section
      id="galeria"
      data-testid="gallery-section"
      className="relative py-24 md:py-32 bg-[#0A0A0A] overflow-hidden"
    >
      <div className="absolute inset-0 bg-noise opacity-[0.025]" />
      <div className="absolute -right-40 top-1/2 w-[500px] h-[500px] bg-red-700/10 blur-[150px] rounded-full" />

      <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Heading */}
        <div className="flex flex-col md:flex-row md:items-end md:justify-between mb-14 gap-8">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6 }}
            className="max-w-2xl"
          >
            <p className="text-xs uppercase tracking-[0.35em] text-red-500 font-bold mb-6 flex items-center gap-3">
              <span className="w-8 h-px bg-red-500" /> Nossa Galeria
            </p>
            <h2 className="font-display text-4xl md:text-5xl lg:text-6xl font-black uppercase leading-[1] tracking-tighter text-white">
              Trabalhos<br />
              <span className="text-red-600">reais.</span>
            </h2>
          </motion.div>
          <motion.p
            initial={{ opacity: 0 }}
            whileInView={{ opacity: 1 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6, delay: 0.2 }}
            className="text-zinc-400 text-base md:text-lg max-w-md font-body leading-relaxed"
          >
            Conheça nossa estrutura e os veículos que confiam na Full Force Car Premium. Clique para ampliar.
          </motion.p>
        </div>

        {/* Bento Grid */}
        <div className="grid grid-cols-2 lg:grid-cols-4 gap-3 md:gap-4 auto-rows-[200px] md:auto-rows-[260px]">
          {PHOTOS.map((p, i) => (
            <motion.button
              key={i}
              type="button"
              onClick={() => setActive(i)}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, amount: 0.1 }}
              transition={{ duration: 0.5, delay: (i % 4) * 0.1 }}
              data-testid={`gallery-photo-${i}`}
              className={`group relative overflow-hidden border border-zinc-800 hover:border-red-600/60 transition-all duration-500 text-left ${p.span}`}
            >
              <img
                src={p.src}
                alt={p.title}
                loading="lazy"
                decoding="async"
                className="absolute inset-0 w-full h-full object-cover transition-transform duration-700 ease-out group-hover:scale-110"
              />
              {/* Dark gradient */}
              <div className="absolute inset-0 bg-gradient-to-t from-black via-black/40 to-transparent opacity-90 group-hover:opacity-100 transition-opacity" />
              {/* Red accent on hover */}
              <div className="absolute inset-0 bg-red-600/0 group-hover:bg-red-600/10 transition-colors duration-500" />

              {/* Tag */}
              <div className="absolute top-3 left-3 z-10">
                <span className="text-[9px] uppercase tracking-widest font-bold text-white bg-red-600/90 px-2.5 py-1 backdrop-blur-sm">
                  {p.tag}
                </span>
              </div>

              {/* Zoom icon */}
              <div className="absolute top-3 right-3 z-10 w-8 h-8 bg-black/60 backdrop-blur-sm border border-white/10 flex items-center justify-center opacity-0 group-hover:opacity-100 transition-all duration-300 group-hover:scale-110">
                <ZoomIn size={14} className="text-white" strokeWidth={1.8} />
              </div>

              {/* Content */}
              <div className="absolute bottom-0 left-0 right-0 p-4 md:p-5 z-10">
                <h3 className="font-display text-base md:text-lg font-bold text-white uppercase tracking-tight leading-tight">
                  {p.title}
                </h3>
                <p className="hidden md:block text-xs text-zinc-300 mt-1.5 leading-relaxed line-clamp-2 opacity-0 group-hover:opacity-100 transition-opacity duration-500 max-w-sm">
                  {p.desc}
                </p>
                <div className="mt-3 h-px w-8 bg-red-600 group-hover:w-full transition-all duration-500" />
              </div>
            </motion.button>
          ))}
        </div>
      </div>

      {/* Lightbox */}
      <AnimatePresence>
        {active !== null && (
          <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            transition={{ duration: 0.25 }}
            className="fixed inset-0 z-[100] bg-black/95 backdrop-blur-md flex items-center justify-center p-4 md:p-10"
            onClick={() => setActive(null)}
            data-testid="gallery-lightbox"
          >
            {/* Close */}
            <button
              type="button"
              onClick={() => setActive(null)}
              data-testid="lightbox-close"
              className="absolute top-5 right-5 z-10 w-12 h-12 flex items-center justify-center border border-white/20 hover:border-red-600 hover:bg-red-600/20 text-white transition-all"
              aria-label="Fechar"
            >
              <X size={22} strokeWidth={1.5} />
            </button>

            {/* Prev */}
            <button
              type="button"
              onClick={(e) => {
                e.stopPropagation();
                setActive((i) => (i - 1 + PHOTOS.length) % PHOTOS.length);
              }}
              data-testid="lightbox-prev"
              className="absolute left-3 md:left-6 z-10 w-12 h-12 md:w-14 md:h-14 flex items-center justify-center border border-white/20 hover:border-red-600 hover:bg-red-600/20 text-white transition-all"
              aria-label="Anterior"
            >
              <ChevronLeft size={24} strokeWidth={1.5} />
            </button>
            {/* Next */}
            <button
              type="button"
              onClick={(e) => {
                e.stopPropagation();
                setActive((i) => (i + 1) % PHOTOS.length);
              }}
              data-testid="lightbox-next"
              className="absolute right-3 md:right-6 z-10 w-12 h-12 md:w-14 md:h-14 flex items-center justify-center border border-white/20 hover:border-red-600 hover:bg-red-600/20 text-white transition-all"
              aria-label="Próxima"
            >
              <ChevronRight size={24} strokeWidth={1.5} />
            </button>

            <motion.div
              key={active}
              initial={{ opacity: 0, scale: 0.96 }}
              animate={{ opacity: 1, scale: 1 }}
              exit={{ opacity: 0, scale: 0.96 }}
              transition={{ duration: 0.3 }}
              className="relative max-w-5xl w-full max-h-[88vh] flex flex-col items-center"
              onClick={(e) => e.stopPropagation()}
            >
              <img
                src={PHOTOS[active].src}
                alt={PHOTOS[active].title}
                className="max-h-[78vh] w-auto object-contain border border-white/10"
              />
              <div className="mt-5 text-center max-w-2xl">
                <p className="text-[10px] uppercase tracking-[0.3em] text-red-500 font-bold mb-2">
                  {PHOTOS[active].tag}
                </p>
                <h3 className="font-display text-xl md:text-2xl font-bold text-white uppercase tracking-tight">
                  {PHOTOS[active].title}
                </h3>
                <p className="text-sm text-zinc-400 mt-2">{PHOTOS[active].desc}</p>
                <p className="mt-4 text-xs text-zinc-600">
                  {active + 1} / {PHOTOS.length}
                </p>
              </div>
            </motion.div>
          </motion.div>
        )}
      </AnimatePresence>
    </section>
  );
}
